import { IconBitbotError } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { Text } from '@chakra-ui/react/text';
import { AxiosError } from 'axios';

type Props = { error: AxiosError | null; onFetch: () => void };

const MessageFailing = ({ error, onFetch }: Props) => {
  const errorStatus = error?.response?.status;

  return (
    <Box display="flex" height="100%" flexDirection="column" alignItems="center" justifyContent="center">
      <IconBitbotError marginBottom="4" />
      <Text truncate textStyle="body/md/regular" color="text/negative">
        {errorStatus === 403 ? "You do not have access to this project's data." : "Uh oh, there's been a problem."}
      </Text>
      {errorStatus !== 403 && (
        <Box asChild textStyle="body/md/regular" textDecoration="underline">
          <button type="button" onClick={onFetch}>
            Click here to retry.
          </button>
        </Box>
      )}
    </Box>
  );
};

export default MessageFailing;
